export default __webpack_public_path__ + "static/media/sh_invoice.59334b7d.svg";